/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * CircleWarningIcon - Auto-generated from icon.js
 */
export const CircleWarningIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7 0C3.13359 0 0 3.13359 0 7C0 10.8664 3.13359 14 7 14C10.8664 14 14 10.8664 14 7C14 3.13359 10.8664 0 7 0ZM7.43749 10.9375C7.43749 11.1795 7.24198 11.375 6.99999 11.375C6.758 11.375 6.56249 11.1795 6.56249 10.9375C6.56249 10.6955 6.758 10.5 6.99999 10.5C7.24198 10.5 7.43749 10.6955 7.43749 10.9375ZM7.43749 9.1875C7.43749 9.42949 7.24198 9.625 6.99999 9.625C6.758 9.625 6.56249 9.42949 6.56249 9.1875V3.0625C6.56249 2.82051 6.758 2.625 6.99999 2.625C7.24198 2.625 7.43749 2.82051 7.43749 3.0625V9.1875Z"
			fill="current"
		/>
	</svg>
);

export default CircleWarningIcon;
